module.exports = __webpack_public_path__ + "static/media/Cohete.b5022d20.png";